export default __webpack_public_path__ + "static/media/vb.80dbd95d.jpeg";